module.exports = new __parcel__URL__("puppy1.ea4757f2.png").toString();